<template>
<div class="panel">
    <div class="panel-content">
    <h2>{{ $t('payments.trial_title') }}</h2>
    <p v-html="$t('payments.trial_subheader')"></p>
    <div class="button-container">
        <router-link :to="{ name: 'survey' }" class="upgrade-button" @click="upgradeAndClosePanel">
          <i class="fas fa-comment"></i> {{ $t('buttons.survey') }}
        </router-link>
        <button @click="cancel">{{ $t('buttons.cancel') }}</button>
    </div>
    </div>
</div>
</template>

<script>
export default {
  methods: {
    cancel() {
      this.$emit('cancel');
    },
    upgradeAndClosePanel() {
      this.$emit('survey');
    }
  }
};
</script>

<style scoped>
  .panel {
    position: absolute;
    z-index: 999;
    background-color: var(--white);
    /* border: 1px solid var(--red); */
    box-shadow: 0 2px 4px var(--dark);
    padding: 10px;
  }

  .panel-content {
    text-align: center;
  }

  .button-container {
    margin-top: 20px;
  }

  .upgrade-button {
    margin-right: 10px;
    padding: 10px 20px;
    background-color: var(--green);
    color: var(--white);
    border: none;
    border-radius: 5px;
    cursor: pointer;
    text-decoration: none; /* Remove underline from router-link */
  }

  .upgrade-button:hover {
    background-color: var(--white);
    color: var(--purple)
  }

  button {
    margin-right: 10px;
    padding: 10px 20px;
    background-color: var(--dark);
    color: var(--white);
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }

  button:hover {
    background-color: var(--white);
    color: var(--purple)
  }
  </style>